import DotLoaderSVG from '../assets/preloader-life.svg';

const DotLoader = () => <DotLoaderSVG />;

export default DotLoader;
